import React from "react";
import {
  DeleteIcon,
  EditIcon,
  EyeIcon,
} from "../../assets/icons/Svgs";
import { showQuestionDeleteAlert } from "../../components/molecules/ShowAlert";

export const PlazoNotasCard = ({
  plazo,
  index,
  grupo,
  docente,
  onDelete,
  onEdit,
  onView,
  onToggleExtension,   
}) => {
  const nombreGrupo   = grupo?.nombre || "Sin grupo";
  const nombreDocente = docente
    ? `${docente.persona?.nombre ?? ""} ${docente.persona?.apellido ?? ""}`.trim()
    : "Sin asignar";

  const inicio = new Date(plazo.fechaInicio).toLocaleDateString("es-BO");
  const fin    = new Date(plazo.fechaFin   ).toLocaleDateString("es-BO");

  const handleDelete = () =>
    showQuestionDeleteAlert({
      callback: (r) => r.isConfirmed && onDelete(plazo.idPlazoNotas),
    });

  return (
    <details className="border rounded-md mb-2">
      <summary className="flex justify-between items-center bg-gray-100 px-4 py-2 cursor-pointer">
        <span>{index}. {nombreGrupo} — {inicio} → {fin}</span>

        <div className="flex gap-2">
          <button
            title={
              plazo.esExtension ? "Quitar extensión" : "Dar extensión"  
            }
            onClick={(e) => {
              e.preventDefault();    
              onToggleExtension(plazo);    
            }}
            className="text-indigo-600 hover:text-indigo-800"
          >
            ⏰
          </button>

          <EditIcon   className="w-5 h-5 text-green-600 hover:text-green-800 cursor-pointer" onClick={() => onEdit(plazo)} />
          <EyeIcon    className="w-5 h-5 text-blue-600  hover:text-blue-800  cursor-pointer" onClick={() => onView(plazo)} />
          <DeleteIcon className="w-5 h-5 text-red-600  hover:text-red-800  cursor-pointer" onClick={handleDelete} />
        </div>
      </summary>

      <div className="px-4 py-3 bg-white space-y-1">
        <p><strong>Docente:</strong> {nombreDocente || "Sin asignar"}</p>
        <p><strong>Fecha de Inicio:</strong> {inicio}</p>
        <p><strong>Fecha de Fin:</strong> {fin}</p>
        <p>
          <strong>¿Extensión?:</strong>{" "}
          {plazo.esExtension ? "Sí" : "No"}
        </p>
      </div>
    </details>
  );
};
